import BotStore from '@src/store';
import { MogamboRequest, captureException } from './index';
import { mogamboRequestV2 } from './utils';
import { BASE_URL } from '../const';
import { createAlert } from '../actions/_utils';

export const copyPasteBotComponents = (data, cb) => {
  const headers = {
    'x-haptik-bot-name': data?.data?.domain[0]?.to,
  };
  const url = `${BASE_URL}copy_paste/`;
  const request = MogamboRequest(url, 'POST', data, headers);

  fetch(request)
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 200 &&
        contentType &&
        contentType.indexOf('application/json') !== -1
      ) {
        return response.json().then((json) => {
          if (response.status) {
            cb(json);
            !BotStore.getDuplicateModalActiveFlag() &&
              createAlert('Bot duplicated successfully.');
          } else {
            showRequestFailureAlert('Error in updating bot');
          }
        });
      }
      console.log('API request failed!');
    })
    .catch(captureException);
};

export const copyPasteAsync = async (data) => {
  const headers = {
    'x-haptik-bot-name': data?.data?.domain[0]?.to,
  };
  const url = `${BASE_URL}copy_paste/`;
  const response = mogamboRequestV2(url, 'POST', data, false, headers);
  return Promise.resolve(response);
};

export const copyPasteTemplateAsync = async (data, callback, botId) => {
  const headers = {
    'x-haptik-bot-name': data?.data?.domain[0]?.to,
  };
  const url = `${BASE_URL}copy_paste/`;
  const request = MogamboRequest(url, 'POST', data, headers);

  await fetch(request)
    .then(async (response) => {
      if (response.status === 200) {
        const res = await response.json();
        callback(res);
      } else {
        const defaultErr = 'Something went wrong.';
        callback({ success: false, error: defaultErr });
        captureException(defaultErr);
      }
    })
    .catch((error) => {
      captureException(error);
    });
};
